/* === Bubble === */
.mxch-bubble {
  position: fixed; bottom: 24px; right: 24px; width: 60px; height: 60px;
  border-radius: 50%; background: var(--mx-primary, #6b46c1); color: #fff; border: none;
  box-shadow: 0 6px 20px rgba(107, 70, 193, 0.35); cursor: pointer; font-size: 26px; z-index: 999999;
  display: flex; align-items: center; justify-content: center; transition: transform 0.15s ease, box-shadow 0.15s;
}
.mxch-bubble:hover { transform: scale(1.05); box-shadow: 0 8px 28px rgba(107, 70, 193, 0.45); }

/* === Panel === */
.mxch-panel {
  position: fixed; bottom: 100px; right: 24px;
  width: 380px; height: 580px;
  background: #ffffff; border: 1px solid #e5e7eb; border-radius: 18px;
  box-shadow: 0 16px 48px rgba(0,0,0,.18); display: flex; flex-direction: column; overflow: hidden; z-index: 999999;
  color: #1a1a1a;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: calc(13px * var(--mx-font-scale, 1));
}
.mxch-panel.mxch-wide {
  width: min(960px, 95vw);
  height: min(680px, 85vh);
  flex-direction: row;
}

/* === Header met avatar === */
.mxch-panel header {
  padding: 14px 18px; border-bottom: 1px solid #f0f0f0;
  display: flex; align-items: center; justify-content: space-between; gap: 10px;
  background: #fff;
}
.mxch-header-id {
  display: flex; align-items: center; gap: 10px; min-width: 0;
}
.mxch-avatar {
  width: 36px; height: 36px; border-radius: 50%;
  background: linear-gradient(135deg, var(--mx-primary, #6b46c1) 0%, #8b5cf6 100%);
  color: #fff; display: flex; align-items: center; justify-content: center;
  font-weight: 700; font-size: 14px; flex-shrink: 0;
  box-shadow: 0 2px 6px rgba(107, 70, 193, 0.25);
}
.mxch-header-text { display: flex; flex-direction: column; min-width: 0; }
.mxch-header-name { font-weight: 600; font-size: 14px; line-height: 1.2; }
.mxch-header-status { font-size: 11px; color: #16a34a; line-height: 1.2; display: flex; align-items: center; gap: 4px; }
.mxch-header-status::before {
  content: ""; width: 7px; height: 7px; border-radius: 50%; background: #16a34a;
  box-shadow: 0 0 0 0 rgba(22, 163, 74, 0.5);
  animation: mxch-pulse 2s infinite;
}
@keyframes mxch-pulse {
  0% { box-shadow: 0 0 0 0 rgba(22, 163, 74, 0.5); }
  70% { box-shadow: 0 0 0 6px rgba(22, 163, 74, 0); }
  100% { box-shadow: 0 0 0 0 rgba(22, 163, 74, 0); }
}
.mxch-header-actions { display: flex; gap: 4px; }
.mxch-icon-btn {
  background: transparent; border: none; cursor: pointer; padding: 6px 8px; font-size: 14px; color: #6b7280; border-radius: 6px;
  font-weight: 500;
}
.mxch-icon-btn:hover { background: #f3f4f6; color: #1a1a1a; }

/* === Chat sectie === */
.mxch-chat-section { display: flex; flex-direction: column; flex: 1; min-width: 0; }
.mxch-messages {
  flex: 1; overflow-y: auto; padding: 18px 16px; display: flex; flex-direction: column; gap: 10px;
  background: #fafafa;
}

/* === Berichten + avatars === */
.mxch-msg-row { display: flex; gap: 8px; align-items: flex-end; }
.mxch-msg-row.mxch-row-user { justify-content: flex-end; }
.mxch-msg-row.mxch-row-assistant { justify-content: flex-start; }

.mxch-msg-avatar {
  width: 28px; height: 28px; border-radius: 50%;
  background: linear-gradient(135deg, var(--mx-primary, #6b46c1) 0%, #8b5cf6 100%);
  color: #fff; display: flex; align-items: center; justify-content: center;
  font-weight: 700; font-size: 11px; flex-shrink: 0; align-self: flex-end;
}

.mxch-msg {
  padding: 10px 14px; border-radius: 18px; max-width: 78%; line-height: 1.45;
  white-space: pre-wrap; word-wrap: break-word;
  box-shadow: 0 1px 2px rgba(0,0,0,.04);
}
.mxch-msg.mxch-user {
  background: #1f2937; color: #fff;
  border-bottom-right-radius: 6px;
}
.mxch-msg.mxch-assistant {
  background: #ffffff; color: #1a1a1a;
  border: 1px solid #f0f0f0;
  border-bottom-left-radius: 6px;
}

/* Typing indicator */
.mxch-msg.mxch-typing {
  display: inline-flex; gap: 4px; align-items: center; padding: 14px 16px;
  background: #ffffff; border: 1px solid #f0f0f0;
  border-bottom-left-radius: 6px;
}
.mxch-msg.mxch-typing span {
  width: 7px; height: 7px; border-radius: 50%; background: var(--mx-primary, #6b46c1);
  animation: mxch-bounce 1.2s infinite ease-in-out;
}
.mxch-msg.mxch-typing span:nth-child(2) { animation-delay: 0.15s; }
.mxch-msg.mxch-typing span:nth-child(3) { animation-delay: 0.30s; }
@keyframes mxch-bounce {
  0%, 60%, 100% { opacity: 0.3; transform: translateY(0); }
  30% { opacity: 1; transform: translateY(-4px); }
}

/* === Input === */
.mxch-input {
  display: flex; align-items: center; border-top: 1px solid #f0f0f0; padding: 12px 14px; gap: 8px;
  background: #fff;
}
.mxch-input input {
  flex: 1; padding: 12px 14px; border: 1px solid #e5e7eb; border-radius: 24px; font: inherit; min-width: 0;
  outline: none; transition: border 0.15s; background: #f9fafb;
}
.mxch-input input:focus { border-color: var(--mx-primary, #6b46c1); background: #fff; }
.mxch-send-btn {
  width: 38px; height: 38px; border-radius: 50%;
  background: var(--mx-primary, #6b46c1); color: #fff; border: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  font-size: 16px; flex-shrink: 0;
  transition: background 0.15s, transform 0.1s;
}
.mxch-send-btn:hover { background: #5b21b6; }
.mxch-send-btn:active { transform: scale(0.94); }
.mxch-send-btn:disabled { background: #d1d5db; cursor: not-allowed; }

/* === Consent === */
.mxch-consent {
  padding: 28px 24px; display: flex; flex-direction: column; gap: 18px;
  text-align: center;
}
.mxch-consent .mxch-avatar { margin: 0 auto 4px; width: 56px; height: 56px; font-size: 22px; }
.mxch-consent p { margin: 0; line-height: 1.55; color: #374151; }
.mxch-consent-actions { display: flex; gap: 8px; }
.mxch-consent-actions button {
  flex: 1; padding: 12px; border-radius: 10px; border: none; cursor: pointer; font: inherit; font-weight: 500;
}
.mxch-consent-actions button.mxch-primary { background: var(--mx-primary, #6b46c1); color: #fff; }
.mxch-consent-actions button.mxch-secondary { background: #f3f4f6; color: #1a1a1a; }

/* === Sidebar (wide modus) === */
.mxch-sidebar {
  width: 280px; flex-shrink: 0;
  background: #fafafa;
  border-right: 1px solid #e5e7eb;
  overflow-y: auto;
  display: flex; flex-direction: column;
}
.mxch-sidebar-head {
  padding: 14px 18px; border-bottom: 1px solid #e5e7eb;
  font-size: 11px; font-weight: 600; text-transform: uppercase; color: #6b7280; letter-spacing: 0.5px;
  display: flex; align-items: center; justify-content: space-between;
  background: #ffffff; position: sticky; top: 0;
}
.mxch-collapse {
  background: transparent; border: none; cursor: pointer; font-size: 16px; color: #6b7280;
  padding: 2px 6px; border-radius: 4px;
}
.mxch-collapse:hover { background: #f3f4f6; color: #1a1a1a; }
.mxch-sec { padding: 14px 18px; border-bottom: 1px solid #f0f0f0; }
.mxch-sec:last-child { border-bottom: none; }
.mxch-sec h4 {
  margin: 0 0 8px 0; font-size: 11px; font-weight: 700; color: #6b7280;
  text-transform: uppercase; letter-spacing: 0.5px;
}
.mxch-sec h4.mxch-clickable { cursor: pointer; user-select: none; }
.mxch-sec h4.mxch-clickable:hover { color: #1a1a1a; }
.mxch-line { font-size: 13px; line-height: 1.4; margin: 2px 0; }
.mxch-muted { color: #6b7280; font-size: 12px; }
.mxch-doel {
  margin-top: 6px; padding: 6px 10px; background: #ede9fe; color: #5b21b6;
  border-radius: 6px; font-size: 12px; font-weight: 500;
}
.mxch-empty { font-size: 12px; color: #9ca3af; font-style: italic; line-height: 1.5; }

.mxch-tags { display: flex; flex-wrap: wrap; gap: 6px; }
.mxch-tag {
  display: inline-block; background: var(--mx-primary, #6b46c1); color: #fff;
  padding: 4px 10px; border-radius: 999px; font-size: 11px; font-weight: 500;
}

.mxch-tasks { list-style: none; padding: 0; margin: 0; }
.mxch-tasks li {
  font-size: 12px; line-height: 1.5; margin: 4px 0; display: flex; align-items: flex-start; gap: 6px;
}
.mxch-task-done { color: #6b7280; text-decoration: line-through; }
.mxch-check { color: var(--mx-primary, #6b46c1); font-weight: 700; }

.mxch-row {
  display: flex; justify-content: space-between; gap: 12px;
  font-size: 12px; padding: 3px 0;
}
.mxch-row span { color: #6b7280; }
.mxch-row b { font-weight: 600; text-align: right; }

.mxch-label-A { color: #16a34a; }
.mxch-label-B { color: #65a30d; }
.mxch-label-C { color: #ca8a04; }
.mxch-label-D { color: #ea580c; }
.mxch-label-E { color: #ea580c; }
.mxch-label-F { color: #dc2626; }
.mxch-label-G { color: #dc2626; }

.mxch-errors {
  margin-top: 8px; padding: 6px 8px; background: #fef3c7; color: #92400e;
  border-radius: 4px; font-size: 11px;
}

@media (max-width: 768px) {
  .mxch-panel.mxch-wide {
    right: 0; bottom: 0; width: 100vw; height: 100vh; border-radius: 0;
    flex-direction: column;
  }
  .mxch-sidebar {
    width: 100%; max-height: 200px; border-right: none; border-bottom: 1px solid #e5e7eb;
  }
}
@media (max-width: 480px) {
  .mxch-panel:not(.mxch-wide) { right: 0; bottom: 0; width: 100vw; height: 100vh; border-radius: 0; }
}
